import { observeOnce } from './lib/inView';
var DATA_SELECTOR = '[data-cowp-count]';
function readConfig(el) {
    var _a, _b, _c, _d, _e, _f, _g;
    var target = Number.parseFloat((_a = el.dataset.countTo) !== null && _a !== void 0 ? _a : '');
    if (!Number.isFinite(target)) {
        return null;
    }
    var decimals = Number.parseInt((_b = el.dataset.countDecimals) !== null && _b !== void 0 ? _b : '0', 10);
    var duration = Number.parseInt((_c = el.dataset.countDuration) !== null && _c !== void 0 ? _c : '1600', 10);
    return {
        target: target,
        decimals: Number.isFinite(decimals) ? Math.max(0, Math.min(4, decimals)) : 0,
        // Server tells us whether it rendered thousands separators, so the last
        // frame matches the server text exactly instead of flipping 1965 → 1.965.
        grouping: el.dataset.countGrouping === '1',
        // Separators of the page language as rendered by the server (fr: narrow
        // no-break space, en: comma …), so every frame looks like the final value.
        thousands: (_d = el.dataset.countThousands) !== null && _d !== void 0 ? _d : '.',
        decimal: (_e = el.dataset.countDecimal) !== null && _e !== void 0 ? _e : ',',
        duration: Number.isFinite(duration) ? Math.max(300, Math.min(4000, duration)) : 1600,
        prefix: (_f = el.dataset.countPrefix) !== null && _f !== void 0 ? _f : '',
        suffix: (_g = el.dataset.countSuffix) !== null && _g !== void 0 ? _g : '',
    };
}
function formatNumber(value, config) {
    var _a = value.toFixed(config.decimals).split('.'), integer = _a[0], fraction = _a[1];
    var grouped = config.grouping
        ? integer.replace(/\B(?=(\d{3})+(?!\d))/g, config.thousands)
        : integer;
    return fraction ? grouped + config.decimal + fraction : grouped;
}
function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
}
function tween(el, config) {
    var write = function (value) {
        el.textContent = config.prefix + formatNumber(value, config) + config.suffix;
    };
    var start = null;
    var step = function (timestamp) {
        if (start === null) {
            start = timestamp;
        }
        var progress = Math.min(1, (timestamp - start) / config.duration);
        if (progress >= 1) {
            // Write the exact target, never an eased approximation of it.
            write(config.target);
            return;
        }
        write(config.target * easeOutCubic(progress));
        window.requestAnimationFrame(step);
    };
    write(0);
    window.requestAnimationFrame(step);
}
export function initFactCounters() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        // Final value is already in the DOM — leave it untouched.
        return;
    }
    var elements = document.querySelectorAll(DATA_SELECTOR);
    elements.forEach(function (el) {
        var config = readConfig(el);
        if (!config) {
            return;
        }
        observeOnce(el, function () { return tween(el, config); });
    });
}
